<!--
 * @Author: DY
 * @Date: 2020-07-22 10:29:27
 * @LastEditTime: 2021-07-16 16:08:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_test\src\views\salesTerminal\statisticalAnalysis\PurchaseDaily.vue
-->
<template>
    <div class="PurchaseDaily">
        <van-nav-bar
            title="采购日报"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <div class="main-wrapper">
            <div class="top-wrapper">
                <div class="select-wrapper">
                    <div class="select-item">
                        <div @click="startTimePicker = true">
                            <span>{{ startTimeValue }}</span>
                            <i class="iconfont iconxiala"></i>
                        </div>
                    </div>
                    <div
                        class="select-item"
                        @click="showPicker = true"
                    >
                        <span>{{ StationName }}</span>
                        <i class="iconfont iconxiala"></i>
                    </div>
                    <!-- 选择场站 -->
                    <van-popup
                        v-model="showPicker"
                        position="bottom"
                    >
                        <van-picker
                            show-toolbar
                            :columns="columns"
                            @cancel="showPicker = false"
                            @confirm="onConfirm"
                        ></van-picker>
                    </van-popup>
                    <!-- 选择时间-->
                    <van-popup
                        v-model="startTimePicker"
                        position="bottom"
                        :overlay="true"
                    >
                        <van-datetime-picker
                            v-model="startCurrentDate"
                            type="date"
                            title="选择年月日"
                            @confirm="startConfirmData"
                            @cancel="startTimePicker = false"
                        ></van-datetime-picker>
                    </van-popup>
                </div>
                <ul class="totalConsumption">
                    <li>
                        <h4>{{ purchaseNumber.supply_count }}</h4>
                        <p>供应单(个)</p>
                    </li>
                    <li>
                        <h4>{{ purchaseNumber.transport_count }}</h4>
                        <p>运输车次(车)</p>
                    </li>
                    <li>
                        <h4>{{ purchaseNumber.total_weight }}</h4>
                        <p>采购量(吨)</p>
                    </li>
                    <li>
                        <h4>{{ purchaseNumber.total_money }}</h4>
                        <p>采购金额(元)</p>
                    </li>
                </ul>
            </div>
            <div class="rawMaterialTable tableStyle">
                <table>
                    <thead>
                        <tr>
                            <th>原材料类型</th>
                            <th>采购量(吨)</th>
                            <th>采购单价(元)</th>
                            <th>采购金额(元)</th>
                        </tr>
                    </thead>
                    <tbody v-if="rawMaterial.length>0">
                        <template v-for="(item, index) in rawMaterial">
                            <tr
                                :key="index"
                                :class="{ 'active': isActive==index }"
                                @click="selectCategory(item.type_code, index)"
                            >
                                <td>{{ item.type_name }}</td>
                                <td>{{ item.total_weight }}</td>
                                <td>{{ item.unit_price }}</td>
                                <td>{{ item.total_money }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="charts">
                <div class="charts_category">
                    <van-tabs v-model="categoryActive" color="#3495FB" @click="categoryClick">
                        <template v-for="(item,index) in category">
                            <van-tab :key="index" :title="item.name"></van-tab>
                        </template>
                    </van-tabs>
                </div>
                <div v-if="categoryTypeCode != 3">
                    <div class="charts_header">
                        <van-tabs
                            type="card"
                            color="#3495FB"
                            v-model="tabActive"
                        >
                            <template v-for="(item,index) in tabData">
                                <van-tab :key="index" :title="item.name"></van-tab>
                            </template>
                        </van-tabs>
                    </div>
                    <div class="chart">
                        <div id="chart1"></div>
                    </div>
                </div>
                <div v-else class="tableStyle bySupplier">
                    <table>
                        <thead>
                            <tr>
                                <th>供应商名称</th>
                                <th>采购量（吨）</th>
                                <th>采购单价(元)</th>
                                <th>采购金额(元)</th>
                            </tr>
                        </thead>
                        <tbody v-if="supplierData.length > 0">
                            <template v-for="(item, index) in supplierData">
                                <tr :key="index">
                                    <td>{{ item.supplier_name }}</td>
                                    <td>{{ item.total_weight }}</td>
                                    <td>{{ item.unit_price }}</td>
                                    <td>{{ item.total_money }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    pieChart,
    lineBarChart,
} from '@/assets/js/charts';

export default {
    // 采购日报
    name: 'purchase-daily',
    components: {},
    props: {},
    data() {
        return {
            // 开始时间text
            startTimeValue: '',
            // 时间弹出层
            startTimePicker: false,
            // 开始时间默认日期
            startCurrentDate: new Date(),
            // 选中场站名称
            StationName: '',
            // 选中场站id
            StationId: '',
            // 场站数据集
            columns: [],
            // 场站弹出层状态
            showPicker: false,
            // 场站初始数据
            StationData: [
                {
                    station_id: '',
                    station_name: '全部',
                },
            ],
            // 头部数据
            purchaseNumber: {
                // 供应单数
                supply_count: 0,
                // 运输车次
                transport_count: 0,
                // 采购量
                total_weight: 0,
                // 采购金额
                total_money: 0,
            },
            // 原材料列表数据
            rawMaterial: [],
            // 原材料列表选中下标
            isActive: 0,

            // 类别tab数据
            category: [{
                name: '按场站',
                code: 1,
            }, {
                name: '近7天趋势',
                code: 2,
            }, {
                name: '供应商',
                code: 3,
            }],
            // 类别tab默认值
            categoryActive: 0,
            // 类别tab code
            categoryTypeCode: 1,

            // tab选项
            tabData: [{
                name: '采购量',
            }, {
                name: '采购金额',
            }],
            // tab默认值
            tabActive: 0,
            // 原材料类型编码
            categoryCode: '',
            // 图表数据
            chartData: [],
            // 按供应商名称
            supplierData: [],
        };
    },
    created() {
        this.startTimeValue = this.formatDate(this.startCurrentDate);
    },
    computed: {},
    watch: {
        startTimeValue(newVal) {
            this.chartData = [];
            if (newVal !== '') {
                if (this.StationData.length < 2) {
                    // 获取场站
                    this.getStationList();
                } else {
                    this.init();
                }
            }
        },
        StationId(newVal) {
            if (newVal !== '') {
                this.category = [{
                    name: '近7天趋势',
                    code: 2,
                }, {
                    name: '供应商',
                    code: 3,
                }];
                this.categoryTypeCode = 2;
            } else {
                this.category = [{
                    name: '按场站',
                    code: 1,
                }, {
                    name: '近7天趋势',
                    code: 2,
                }, {
                    name: '供应商',
                    code: 3,
                }];
                this.categoryTypeCode = 1;
            }
            this.categoryActive = 0;
            if (this.categoryTypeCode === 1) {
                // 原材料类型统计——按场站
                this.rawMaterialStatistics_station();
            } else if (this.categoryTypeCode === 2) {
                // 原材料类型统计——按近七天
                this.rawMaterialStatistics_week();
            }
        },
        categoryCode() {
            this.getData();
        },
        chartData() {
            // 处理图表数据
            this.handleChartData();
        },
        tabActive() {
            // 处理图表数据
            this.handleChartData();
        },
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 获取企业下所有场站
        getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        station_name: stationNames[index],
                    };
                });
                this.StationData.push(...stationList);
                this.columns = this.StationData.map(item => item.station_name);
                this.StationName = this.columns[0];
                this.StationId = this.StationData[0].station_id;
                this.init();
            }
        },
        // 页面初始化
        init() {
            // 获取头部任务数数据
            this.getPurchaseNumberData();
            // 获取原材料列表数据
            this.getRawMaterialData();
        },
        // 获取头部采购数数据
        getPurchaseNumberData() {
            this.$axios
                .post('/interfaceApi/report/statisticalanalysis/procurement/getstatisticalblock', {
                    start_time: this.startTimeValue,
                    station_id: this.StationId,
                })
                .then(res => {
                    this.purchaseNumber = res;
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 获取原材料列表数据
        getRawMaterialData() {
            this.supplierData = [];
            this.$axios
                .post('/interfaceApi/report/statisticalanalysis/procurement/statisticalmaterialcategory', {
                    start_time: this.startTimeValue,
                    station_id: this.StationId,
                })
                .then(res => {
                    this.rawMaterial = res;
                    if (res.length > 0) {
                        // 默认选择第一个
                        this.selectCategory(res[0].type_code, 0);
                        this.$forceUpdate();
                    }
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // tab类型切换
        categoryClick() {
            this.categoryTypeCode = this.category[this.categoryActive].code;
            this.getData();
        },
        // 选择原材料
        selectCategory(code, index) {
            this.categoryCode = code;
            this.isActive = index;
            this.getData();
        },
        getData() {
            if (this.categoryTypeCode === 1) {
                // 原材料类型统计——按场站
                this.rawMaterialStatistics_station();
            } else if (this.categoryTypeCode === 2) {
                // 原材料类型统计——按近七天
                this.rawMaterialStatistics_week();
            } else {
                // 原材料类型统计——供应商
                this.rawMaterialStatistics_supplier();
            }
        },
        // 原材料类型统计——按场站
        rawMaterialStatistics_station() {
            if (this.rawMaterial.length > 0) {
                const curRow = this.rawMaterial[this.isActive];
                this.chartData = [];
                this.$axios
                    .post('/interfaceApi/report/statisticalanalysis/procurement/statisticalmaterialcategory/station', {
                        start_time: this.startTimeValue,
                        station_id: this.StationId,
                        type_code: this.categoryCode,
                        type_dic_code: curRow.type_dic_code,
                        child_type_code: curRow.child_type_code,
                        child_type_dic_code: curRow.child_type_dic_code,
                        spec_code: curRow.spec_code,
                        spec_dic_code: curRow.spec_dic_code,
                    })
                    .then(res => {
                        this.chartData = res;
                    })
                    .catch(error => {
                        this.$toast.fail(error.ErrorCode.Message);
                    });
            }
        },
        // 原材料类型统计——按近七天
        rawMaterialStatistics_week() {
            if (this.rawMaterial.length > 0) {
                const curRow = this.rawMaterial[this.isActive];
                this.chartData = [];
                this.$axios
                    .post('/interfaceApi/report/statisticalanalysis/procurement/statisticalmaterialcategory/week', {
                        start_time: this.startTimeValue,
                        station_id: this.StationId,
                        type_code: this.categoryCode,
                        type_dic_code: curRow.type_dic_code,
                        child_type_code: curRow.child_type_code,
                        child_type_dic_code: curRow.child_type_dic_code,
                        spec_code: curRow.spec_code,
                        spec_dic_code: curRow.spec_dic_code,
                    })
                    .then(res => {
                        this.chartData = res;
                    })
                    .catch(error => {
                        this.$toast.fail(error.ErrorCode.Message);
                    });
            }

        },
        // 原材料类型统计——供应商
        rawMaterialStatistics_supplier() {
            this.supplierData = [];
            this.$axios
                .post('/interfaceApi/report/statisticalanalysis/procurement/statisticalmaterialcategory/supplier', {
                    start_time: this.startTimeValue,
                    station_id: this.StationId,
                    type_code: this.categoryCode,
                })
                .then(res => {
                    this.supplierData = res;
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 处理图表数据
        handleChartData() {
            if (this.categoryTypeCode === 1) {
                const chartData = {
                    series: {
                        data: [],
                    },
                };
                if (this.tabActive === 0) {
                    this.chartData.forEach(item => {
                        chartData.series.data.push({
                            name: item.station_name,
                            value: item.total_weight,
                        });
                    });
                } else if (this.tabActive === 1) {
                    this.chartData.forEach(item => {
                        chartData.series.data.push({
                            name: item.station_name,
                            value: item.total_money,
                        });
                    });
                }
                pieChart('chart1', chartData);
            } else if (this.categoryTypeCode === 2) {
                const chartData = {
                    xdata: [],
                    legendData: [],
                    grid: [],
                    yAxisName: [],
                    ydata: [
                        {
                            name: '',
                            type: 'bar',
                            color: ['#55A7FE', '#3E79C5'],
                            data: [],
                        }, {
                            name: '单价',
                            type: 'line',
                            color: ['#FA8436'],
                            data: [],
                        },
                    ],
                };
                if (this.tabActive === 0) {
                    chartData.grid = ['40', '60', '40', '20'];
                    chartData.yAxisName = ['(吨)', '(元)'];
                    chartData.legendData = ['采购量', '单价'];
                    chartData.ydata[0].name = '采购量';
                    this.chartData.forEach(item => {
                        chartData.xdata.push(item.day);
                        chartData.ydata[0].data.push(item.total_weight);
                        chartData.ydata[1].data.push(item.unit_price);
                    });
                } else if (this.tabActive === 1) {
                    chartData.grid = ['60', '60', '40', '20'];
                    chartData.yAxisName = ['(元)', '(元)'];
                    chartData.legendData = ['采购金额', '单价'];
                    chartData.ydata[0].name = '采购金额';
                    this.chartData.forEach(item => {
                        chartData.xdata.push(item.day);
                        chartData.ydata[0].data.push(item.total_money);
                        chartData.ydata[1].data.push(item.unit_price);
                    });
                }
                lineBarChart('chart1', chartData);
            }
        },
        // 确认选择场站
        onConfirm(val, index) {
            this.showPicker = false;
            this.StationName = this.StationData[index].station_name;
            this.StationId = this.StationData[index].station_id;
            this.init();
        },
        // 确认选择时间
        startConfirmData(val) {
            this.startTimeValue = this.formatDate(val);
            this.startTimePicker = false;
            this.init();
        },
        // 时间格式处理
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },

    },
};
</script>
<style lang="stylus">
.PurchaseDaily
    height 100%
    .main-wrapper
        height calc(100% - 45rpx)
        overflow scroll
        -webkit-overflow-scrolling touch
    .top-wrapper
        padding 15rpx
        padding-bottom 0
        .select-wrapper
            height 45rpx
            box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.16)
            border-radius 8px
            display flex
            background #ffffff
            position relative
            &:before
                content ''
                height 20rpx
                position absolute
                left 50%
                top 50%
                margin-top -10rpx
                border-left 3rpx solid #D7D7D7
            .select-item
                flex 1
                text-align center
                span
                    font-size 14rpx
                    font-weight 400
                    line-height 45rpx
                i
                    color #979EA7
                &:last-child
                    span
                        color #3495FB
                        padding-left 20rpx
                &:first-child
                    display flex
                    div
                        flex 1
                    p
                        line-height 45rpx
                        color #979EA7
                        font-weight 600
        .totalConsumption
            display flex
            li
                flex 1
                text-align center
                margin 10rpx 0
                p
                    font-size 10rpx
                    color #979EA7
                h4
                    font-size 18rpx
                    line-height 30rpx
                    color #FA8436
                &:nth-of-type(1)
                    h4
                        color #5588F1
                &:nth-of-type(2)
                    h4
                        color #FA8436
                &:nth-of-type(3)
                    h4
                        color #21BDCC
                &:nth-of-type(4)
                    h4
                        color #FFB729
    .rawMaterialTable
        border-bottom 15rpx solid #F0F0F0
        padding 0 15rpx 15rpx 15rpx
    .tableStyle
        table
            width 100%
        td,th
            font-size 14rpx
            height 40rpx
            text-align center
            padding 0 5rpx
        th
            background:rgba(85,136,241,0.1);
            color #333333
            font-weight 400
        td
            color #5588F1
            background rgba(85,136,241,0.04)
        tr
            td
                &:nth-of-type(1)
                    color #333333
                    background rgba(85,136,241,0.1);
        tbody
            tr
                &.active
                    box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                    td
                        background #FA8436
                        color #FFFFFF
                        &:nth-of-type(1)
                            background #F5F2ED
                            color #823802
    .charts
        .charts_category
            .van-tabs
                .van-tab--active
                    color #3495FB
        .charts_header
            width 200rpx
            margin 12rpx auto
            .van-tabs__nav
                margin 0
        .chart
            padding 0 10rpx
            height 240rpx
            margin-bottom 20rpx
            >div
                height 100%
    .bySupplier
        padding 15rpx
        table
            th
                border 1px solid #DEE3EF
            td
                color #333333
                border 1px solid #F0F0F0
                background rgba(85, 136, 241, 0.04)
                &:nth-of-type(1)
                    background rgba(85, 136, 241, 0.04)
</style>
